import installationInstructions from './installationInstructions';

const airPurifierCategoryContent = {
  installationInstructions
}

export { airPurifierCategoryContent };
